import React from 'react';
import ReactGA from 'react-ga';
import './error.css';

class ErrorPage extends React.Component {

    render(){
        return (
            <div className="error-message-container container">
                <div className="inner-error-container">
                    <h2 className="mb-4">This probably isn't the page you were looking for. We're sorry about that.</h2>

                    <div className="error-message">
                        <p>Please don't be alarmed. Follow one of the steps below to resolve your issue.</p>

                        <ol>
                            <li>
                                If you did intend to reach Common App Insight, please <ReactGA.OutboundLink eventLabel="control-center-sign-in" to="https://members.commonapp.org/">sign into Control Center</ReactGA.OutboundLink> first and click the link to Common App Insight.
                            </li>
                            <li>
                                If you've tried that already and ended up here again, try the following:
                                <ul>
                                    <li>
                                        Close your browser and <ReactGA.OutboundLink eventLabel="control-center-sign-in" to="https://members.commonapp.org/">sign in again</ReactGA.OutboundLink>.
                                    </li>
                                    <li>
                                        Make sure that you are using the most up-to-date version of your browser. Please review this FAQ for <ReactGA.OutboundLink eventLabel="supported-browsers-faq" to="https://appsupport.commonapp.org/ics/support/KBAnswer.asp?questionID=27">
                                            more information on supported browsers
                                        </ReactGA.OutboundLink>.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                Still having trouble? Contact your Member Relations Representative, or email <a href="mailto:caohelp@commonapp.net">caohelp@commonapp.net</a> for assistance. Please be sure to include:
                                <ul>
                                    <li>
                                        The email you use to sign in to your account
                                    </li>
                                    <li>
                                        A detailed description of what you were attempting to do when you encountered this page
                                    </li>
                                    <li>
                                        Which browser (e.g., Chrome, Firefox) and operating system (e.g., Windows, Mac) you are using.
                                    </li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        )
    }
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/components/errorPage/ErrorPage.jsx